exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.share-badge[data-v-2c71b00e] {\n    position: relative;\n    top: -12px;\n    left: 12px;\n    display: inline-block;\n    font-size: .50em;\n}\n", ""]);

// exports
